import { render, staticRenderFns } from "./BackofficeRouter.vue?vue&type=template&id=bbdc8d88&"
import script from "./BackofficeRouter.vue?vue&type=script&lang=ts&"
export * from "./BackofficeRouter.vue?vue&type=script&lang=ts&"
import style0 from "./BackofficeRouter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports